<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <span class="pageSteps card-styling">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>
        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Lojas</p>
      </span>
      <div id="divTable" style="margin-top: 32px">
        <section
          class="d-flex justify-content-between align-items-center w-100 flex-wrap"
        >
          <div class="d-flex justify-content-between w-100">
            <div class="w-50 text-secondary fs-5">Lojas Cadastradas</div>
            <div class="d-flex align-items-center" style="gap: 8px">
              <b-button
                variant="primary"
                @click.prevent="logInWithFacebook"
                >Atualizar Token</b-button
              >
              <button
                class="btnPrimaryWhite"
                @click.prevent="showModalFacebook"
              >
                Novo Instagram
              </button>
              <div class="input-container">
                <InputSearch @onUpdate="(value) => getStoreByName(value)" />
              </div>
            </div>
          </div>

          <div class="table-responsive w-100">
            <table class="table align-middle">
              <thead class="thead">
                <tr style="height: 50px">
                  <th>Loja</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in stores" :key="item.instaId">
                  <td>{{ item.instaPageName }}</td>
                  <td
                    :class="[
                      item.pageTokenStatus === 'True' ? '' : 'text-danger',
                    ]"
                  >
                    {{ item.pageTokenStatus === "True" ? "Válido" : "Vencido" }}
                  </td>
                  <td>
                    <div
                      class="w-100 d-flex justify-content-end"
                      v-if="item.pageTokenStatus === 'False'"
                    ></div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination
              :count="totalStores"
              :offset="offset"
              @firstPage="pagination('clickFirstPage', false)"
              @previousPage="pagination('clickPreviousPage', false)"
              @nextPage="pagination('clickNextPage', false)"
              @lastPage="pagination('clickLastPage', false)"
            />
          </div>
        </section>
      </div>
    </div>
    <Modal :showModal="modal">
      <div class="modal-update">
        <div class="fs-5">Lojas Atualizadas!</div>
        <div class="list-store">
          <p v-for="(store, index) in upStores" :key="index">{{ store }}</p>
        </div>
        <b-button class="w-75" variant="primary" @click="reloadPage"
          >Continuar</b-button
        >
      </div>
    </Modal>
    <FacebookLogin ref="modalFacebook" @showIsLoading="showIsLoading" />
  </div>
</template>

<script>
import { ref } from "vue";
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import Loading from "vue-loading-overlay";
import FacebookLogin from "../components/FacebookLogin.vue";
import moment from "moment/moment";
import Modal from "@/components/ui/modal/modal.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: { InputSearch, Loading, Pagination, FacebookLogin, Modal },
  data() {
    return {
      stores: [],
      totalStores: 0,
      offset: 0,
      nameToSearch: "",
      isLoading: false,
      modal: ref(false),
      upStores: [],
      facebookScopes: "email, manage_fundraisers, user_messenger_contact, threads_business_basic, pages_show_list, read_page_mailboxes, business_management, pages_messaging_phone_number, pages_messaging_subscriptions, instagram_basic, instagram_manage_comments, instagram_manage_insights, instagram_content_publish, pages_read_engagement, pages_manage_metadata, pages_read_user_content, pages_manage_ads, pages_manage_posts, pages_manage_engagement, instagram_branded_content_brand, instagram_branded_content_creator, instagram_branded_content_ads_brand, instagram_manage_events, instagram_manage_upcoming_events, pages_utility_messaging, paid_marketing_messages, instagram_creator_marketplace_discovery, facebook_creator_marketplace_discovery, public_profile, ads_management, ads_read, attribution_read, manage_app_solution, page_events, pages_manage_instant_articles, pages_manage_cta, pages_messaging, catalog_management, whatsapp_business_manage_events, read_insights, publish_video, leads_retrieval, instagram_manage_messages, commerce_account_manage_orders, commerce_account_read_orders, commerce_account_read_reports, commerce_account_read_settings, instagram_shopping_tag_products"
    };
  },
  async created() {
    this.isLoading = true;

    await this.getInstagramRelationship({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 5,
    })
      .then((response) => {
        this.totalStores = response.data.count;
        this.stores = response.data.data;

        this.isLoading = false;
      })
      .catch((err) => console.log(err));
  },

  computed: {
    ...mapGetters(["getOffset"]),
  },

  methods: {
    ...mapActions([
      "getInstagramRelationship",
      "carregarPorFacebookUser",
      "atualizarToken",
    ]),
    ...mapMutations(["SET_OFFSET"]),
    reloadPage() {
      window.location.reload();
    },

    async updateTokenFacebook(data) {
      try {
        const response = await this.atualizarToken({
          fbUserId: data?.userID,
          fbUserToken: data?.accessToken,
        });

        if (response?.status === 200) {
          this.upStores = response.data;
          this.modal = true;
        }
      } catch (error) {
        console.error(error);
        alert("Houve um error ao atualizar");
      }
    },
    async logInWithFacebook() {
      const loginOptions = {
        scope: this.facebookScopes,
        return_scopes: true,
      };

      window.FB.login(
        (response) => {

          if (response.authResponse) {
            this.updateTokenFacebook(response.authResponse);
          } else {
            alert("Usúario não existe ou não autorizado!");
          }
        },
        loginOptions
      );
      return false;
    },
    async initFacebook() {
      window.fbAsyncInit = function () {
        if (process.env.NODE_ENV == "production") {
          window.FB.init({
            cookie: true,
            appId: "883873419293715",
            version: "v15.0",
          });
        } else {
          window.FB.init({
            appId: "855326342519443",
            cookie: true,
            version: "v14.0",
          });
        }
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },

    currentDateTime(timestamp) {
      const date = moment(timestamp).format("DD/MM/YY");
      const hour = moment(timestamp).format("HH:mm");
      return `${date} às ${hour}`;
    },

    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },

    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 5,
      };
      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getInstagramRelationship(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getInstagramRelationship(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getInstagramRelationship(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getInstagramRelationship(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
    showModalFacebook() {
      this.$refs["modalFacebook"].$refs["modal-Facebook"].show();
    },
    showIsLoading(newValue) {
      this.isLoading = newValue;
    },
  },
};
</script>

<style>
#divTable {
  width: 100%;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 24px 16px 24px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  margin-bottom: 22px;
}

.input-container {
  background: #f0f2f8;
  border-radius: 8px;
  width: 310px;
  height: 42px;
  max-width: 310px;
  margin-left: 10px;
}

.modal-update {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 18px;
  justify-content: space-between;
  align-items: center;
}

.list-store {
  display: block;
  width: 70%;
  height: 188px;
  overflow: auto;
}
</style>
